import {initWebComponent} from "@/helpers/web-component-helper";
import {initDatePicker, initTimePicker, resetDatePicker} from "@/helpers/date-picker-helper";

const template = document.createElement('template');

export class FormDateComponent extends HTMLElement {
    constructor() {
        super();
        const name = this.getAttribute('data-name')
        const attributeID = this.getAttribute('data-attribute-id')

        template.innerHTML = `
          <div class="row">
                <div class="col-12">
                   <div class="form-group text-primary mt-3 mb-0">
                    <h2>` + name + `</h2>
                    </div>
                </div>
           </div>
          <div class="row">
                <div class="col-6">
                    <div class="form-group text-primary ">
                        <div class="input-group">
                            <input type="text" id="iptNewNotificationDate-${attributeID}" class="form-control iptNewNotificationDate">
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group text-primary">
                        <select size="1" class="form-control iptNotificationTime" id="iptNotificationTime-${attributeID}" style="margin-top:7px">
                        </select>
                    </div>
                </div>
          </div>`

        initWebComponent(this, template)

        initDatePicker(attributeID)
        initTimePicker(attributeID)

        setTimeout(() => {
            resetDatePicker()
        }, 5000)

        this.addEventListener('change', (element) => {

        })
    }
}
